<template>
    <div class="privacy-policy nunito">
      <h1>Política de Privacidad</h1>
      <div class="content">
        <section>
          <h2>1. Información que recopilamos</h2>
          <p>
            Recopilamos varios tipos de información con el fin de proporcionar y mejorar nuestro servicio para usted.
          </p>
        </section>
        <section>
          <h2>2. Uso de la información</h2>
          <p>
            Utilizamos la información recopilada para diversos fines, como para proporcionar y mantener nuestro servicio,
            para notificarle sobre cambios en nuestro servicio, y para proporcionarle soporte.
          </p>
        </section>
        <section>
          <h2>3. Divulgación de la información</h2>
          <p>
            No compartimos su información personal con terceros excepto cuando sea necesario para cumplir con la ley,
            para proteger nuestros derechos, o para proporcionar y mejorar nuestros servicios.
          </p>
        </section>
        <section>
          <h2>4. Seguridad de la información</h2>
          <p>
            La seguridad de su información es importante para nosotros. Utilizamos medidas de seguridad estándar de la
            industria para proteger su información personal.
          </p>
        </section>
        <section>
          <h2>5. Cambios a esta Política de Privacidad</h2>
          <p>
            Podemos actualizar nuestra Política de Privacidad de vez en cuando. Le notificaremos cualquier cambio
            publicando la nueva Política de Privacidad en esta página.
          </p>
        </section>
        <section>
          <h2>6. Contacto</h2>
          <p>
            Si tiene alguna pregunta sobre esta Política de Privacidad, por favor contáctenos.
          </p>
        </section>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PrivacyPolicyComponent',
  };
  </script>
  
  <style lang="scss" scoped>
  .privacy-policy {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    line-height: 1.6;
  
    h1 {
      text-align: center;
      margin-bottom: 20px;
      font-size: 2.5rem;
    }
  
    .content {
      section {
        margin-bottom: 20px;
  
        h2 {
          font-size: 1.5rem;
          margin-bottom: 10px;
        }
  
        p {
          font-size: 1rem;
        }
      }
    }
  }
  </style>
  